import { render, staticRenderFns } from "./PackageDocument.vue?vue&type=template&id=fe806fcc"
import script from "./PackageDocument.ts?vue&type=script&lang=ts&external"
export * from "./PackageDocument.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe806fcc')) {
      api.createRecord('fe806fcc', component.options)
    } else {
      api.reload('fe806fcc', component.options)
    }
    module.hot.accept("./PackageDocument.vue?vue&type=template&id=fe806fcc", function () {
      api.rerender('fe806fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/PackageDocument/PackageDocument.vue"
export default component.exports